import { Tab, TabList, Divider, Button } from "@fluentui/react-components";
import { useState } from "react";
import "../style.css";
import { ArrowClockwise24Filled, Edit24Filled } from "@fluentui/react-icons";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../redux/store";
import ReceivedMessages from "./ReceivedMessages";
import SentMessages from "./SentMessages";
import ComposeMessage from "./composeMessage";
import { fetchCustomerMessages } from "../../../../redux/clientPortal/clientPortalslice";

enum TabValues {
  tab1 = "received",
  tab2 = "sent",
}
interface messageProps {
  customerId: string;
  notify: (
    title: string,
    message: string,
    type: "success" | "error" | "warning"
  ) => void;
  partnerId?: string;
  idsToMatch?: any;
  customerMessages?: any;
}

function Messages({ customerId, notify, customerMessages }: messageProps) {
  const dispatch = useDispatch<AppDispatch>();
  const [openCompose, setOpenCompose] = useState<boolean>(false);
  const receivedMessages = customerMessages?.received;
  const sentMessages = customerMessages?.sent;

  const unreadMessagesCount =
    receivedMessages?.filter((msg: any) => !msg.Read).length || 0;

  const [selectedTab, setSelectedTab] = useState<TabValues>(TabValues.tab1);

  const handleComposeClick = () => {
    setOpenCompose(true);
  };
  return (
    <>
      <div className="cp_card">
        <div className="portal_card_header">
          <div className="justify_between">
            <div className="portal_heading">
              <h5 className="grey_bold_text">Messages</h5>
              <p className="unread_count">{unreadMessagesCount.toString()}</p>
              <ArrowClockwise24Filled
                onClick={() => dispatch(fetchCustomerMessages({ customerId }))}
              />
            </div>
            <div style={{ padding: "0 10px" }}>
              <Button
                appearance="primary"
                className="asc-button-primary"
                icon={<Edit24Filled />}
                onClick={handleComposeClick}
              >
                Compose
              </Button>
            </div>
          </div>

          <TabList
            defaultSelectedValue={TabValues.tab1}
            onTabSelect={(event, data) =>
              setSelectedTab(data.value as TabValues)
            }
          >
            <Tab value={TabValues.tab1}>Received</Tab>
            <Tab value={TabValues.tab2}>Sent</Tab>
          </TabList>
        </div>
        <Divider />
        <div className="data_body">
          {selectedTab === TabValues.tab1 && (
            <ReceivedMessages
              customerId={customerId}
              notify={notify}
              receivedMessages={receivedMessages}
            />
          )}
          {selectedTab === TabValues.tab2 && (
            <SentMessages
              customerId={customerId}
              notify={notify}
              sentMessages={sentMessages}
            />
          )}
        </div>
      </div>
      <ComposeMessage
        open={openCompose}
        customerId={customerId}
        notify={notify}
        onClose={() => setOpenCompose(false)}
      />
    </>
  );
}

export default Messages;
